module.exports = __webpack_public_path__ + "static/media/solution-selection@2x.ec546f72.png";